var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpotlight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 1.75C4.54822 1.75 1.75 4.54822 1.75 8C1.75 11.4518 4.54822 14.25 8 14.25C11.4518 14.25 14.25 11.4518 14.25 8C14.25 4.54822 11.4518 1.75 8 1.75ZM0.25 8C0.25 3.71979 3.71979 0.25 8 0.25C12.2802 0.25 15.75 3.71979 15.75 8C15.75 12.2802 12.2802 15.75 8 15.75C3.71979 15.75 0.25 12.2802 0.25 8Z",
    fill: "#313131"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.16471 3.96731C7.52406 3.30403 8.47594 3.30403 8.83529 3.96731L9.73004 5.61881L11.5772 5.95942C12.3191 6.09622 12.6132 7.00151 12.0934 7.54823L10.7993 8.90953L11.0461 10.7715C11.1453 11.5194 10.3752 12.0789 9.69459 11.7535L8 10.9433L6.30541 11.7535C5.62482 12.0789 4.85474 11.5194 4.95389 10.7715L5.20075 8.90953L3.90657 7.54823C3.3868 7.00151 3.68095 6.09622 4.42281 5.95942L6.26997 5.61881L7.16471 3.96731ZM8 5.57444L7.46359 6.56455C7.32677 6.81709 7.08303 6.99417 6.80057 7.04626L5.69317 7.25046L6.46905 8.06658C6.66695 8.27474 6.76005 8.56127 6.7223 8.846L6.5743 9.96231L7.59024 9.4766C7.84937 9.35271 8.15064 9.35271 8.40977 9.4766L9.42571 9.96231L9.27771 8.846C9.23996 8.56127 9.33306 8.27474 9.53096 8.06658L10.3068 7.25046L9.19943 7.04626C8.91697 6.99417 8.67324 6.81709 8.53642 6.56455L8 5.57444Z",
    fill: "#313131"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotlight);
export default __webpack_public_path__ + "static/media/spotlight.9706ad9b749bd786327b00a77e707edc.svg";
export { ForwardRef as ReactComponent };